import React from 'react';
import Navbar from '../../components/navbar';
import FormularioDefinicionServicio from '../../formData/formularioDefinicionServicio';

function DefinicionServicio() {
  return (
    <FormularioDefinicionServicio />
  )
}

export default DefinicionServicio;
